import { render, staticRenderFns } from "./product-pending-projects.vue?vue&type=template&id=5fc825a3&scoped=true&"
import script from "./product-pending-projects.vue?vue&type=script&lang=js&"
export * from "./product-pending-projects.vue?vue&type=script&lang=js&"
import style0 from "./product-pending-projects.vue?vue&type=style&index=0&id=5fc825a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc825a3",
  null
  
)

export default component.exports